import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20fashion%20lifestyle%20flatlay%20with%20colorful%20sneakers%20hoodies%20and%20bags%20arranged%20on%20pure%20white%20surface%2C%20bright%20clean%20natural%20lighting%2C%20editorial%20product%20photography%2C%20full%20color%20spectrum%20items%2C%20crisp%20shadows%2C%20contemporary%20retail%20aesthetic&width=1600&height=1000&seq=kakobuy-hero-bg-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet products background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 pt-20">
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20 max-w-7xl mx-auto">
          <div className="flex-1 pt-10 lg:pt-20">
            <div className="flex items-center gap-3 mb-6">
              <div className="flex -space-x-2">
                <div className="w-8 h-8 rounded-full bg-background-200 border-2 border-background-50 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20white%20sneaker%20on%20light%20beige%20background%2C%20soft%20natural%20light%2C%20top-down%20view%2C%20simple%20composition&width=64&height=64&seq=kakobuy-avatar-01&orientation=squarish"
                    alt="Product"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-8 h-8 rounded-full bg-background-200 border-2 border-background-50 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20black%20hoodie%20folded%20on%20light%20beige%20background%2C%20soft%20natural%20light%2C%20top-down%20view%2C%20simple%20composition&width=64&height=64&seq=kakobuy-avatar-02&orientation=squarish"
                    alt="Product"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-8 h-8 rounded-full bg-background-200 border-2 border-background-50 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20brown%20leather%20bag%20on%20light%20beige%20background%2C%20soft%20natural%20light%2C%20top-down%20view%2C%20simple%20composition&width=64&height=64&seq=kakobuy-avatar-03&orientation=squarish"
                    alt="Product"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <span className="text-sm text-background-50/90 font-medium">{t("hero.social_proof")}</span>
            </div>

            <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-background-50 leading-none tracking-tight">
              {t("hero.title_line1")}
              <br />
              <span className="font-serif italic font-bold">{t("hero.title_line2")}</span>
            </h1>

            <p className="mt-6 text-sm md:text-base text-background-50/80 max-w-lg leading-relaxed">
              {t("hero.subtitle")}
            </p>

            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 bg-background-50 text-foreground-900 rounded-full text-sm font-semibold hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span>{t("hero.cta")}</span>
              <span className="w-6 h-6 rounded-full bg-foreground-900 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs text-background-50"></i>
              </span>
            </a>
          </div>

          <div className="flex-1 lg:pt-32 pb-16 lg:pb-0">
            <p className="text-sm md:text-base text-background-50/70 leading-relaxed max-w-md lg:ml-auto">
              {t("hero.desc")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}